import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Speaker } from './../../../API.service'
import { SelectorMode } from '../../_common/selector-mode/selector-mode'

@Component({
    selector: 'pia3-speaker-selector-multi',
    templateUrl: './pia3-speaker-selector-multi.component.html',
    styleUrls: ['./pia3-speaker-selector-multi.component.scss'],
})
export class Pia3SpeakerSelectorMultiComponent implements OnInit {
    @Input('clientID') clientID!: string
    selectorMode: string = SelectorMode.MULTI
    @Output('speakerSelected') speakersSelected = new EventEmitter<Speaker[]>()

    constructor() {}

    ngOnInit() {}

    _speakerSelected($event) {
        this.speakersSelected.emit($event)
    }
}
